import { render, staticRenderFns } from "./DepositReceiveAdd.vue?vue&type=template&id=9eada970&scoped=true"
import script from "./DepositReceiveAdd.vue?vue&type=script&lang=js"
export * from "./DepositReceiveAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9eada970",
  null
  
)

export default component.exports